import { render, staticRenderFns } from "./mobileHeaderSticky.vue?vue&type=template&id=4afc584c&"
import script from "./mobileHeaderSticky.vue?vue&type=script&lang=js&"
export * from "./mobileHeaderSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports